<div class="bg-[url(/assets/backgrounds/login-screen.png)] bg-center bg-cover">
  <div class="flex items-center justify-center min-h-dvh backdrop-brightness-80 backdrop-blur-xs">
    <!-- <img src="assets/backgrounds/login-screen-full.png" alt=""> -->
    <section class="w-full max-w-lg p-8 py-6 pt-4 rounded-lg bg-white/90 shadow max-h-dvh overflow-auto">
      <header class="mb-4 mt-4 flex flex-col items-center justify-center gap-4">
        <img src="assets/logos/bra_logo.svg" alt="Botanical Resources Australia logo" width="80px" height="80px">
        <h1 class="text-2xl text-black font-bold text-center">BRA Field App</h1>
        <!-- <div class="w-14"></div> -->
      </header>
      <main>
        <form [formGroup]="form" (ngSubmit)="formState.submit()" class="space-y-4">
          <tui-input formControlName="email">
            Email
            <input tuiTextfieldLegacy type="email" />
          </tui-input>

          <tui-input formControlName="password">
            Password
            <input tuiTextfieldLegacy type="password" />
          </tui-input>

          @if(formState.status() == 'error')
          {
            <div
            class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-sm relative"
            role="alert"
          >
            <span class="block sm:inline">{{ formState.errorMessage() }}</span>
          </div>
          }

          <div class="actions">
            <tui-loader
            class="loader"
            [inheritColor]="true"
            [overlay]="true"
            [showLoader]="formState.status() == 'submitting'"
        >
            <button
              tuiButton
              appearance="primary"
              size="l"
              type="submit"
              [disabled]="!form.valid"
              class="w-full"
            >

              Login
            </button>
            </tui-loader>
          </div>
        </form>
      </main>
      <footer
        *ngIf="version"
        class="mt-4 flex justify-between items-center text-sm"
      >
        <a class="text-blue-500 hover:underline" routerLink="/forgot-password"
          >Forgot Password?</a
        >
        <span class="text-gray-500">{{ version }}</span>
      </footer>
    </section>
  </div>
</div>
